/** Named HTTP status codes used across the frontend. */
export const HTTP = {
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  RATE_LIMITED: 429,
};
